import {Component, OnInit, Inject, DestroyRef, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup} from '@angular/forms';
import {Observable} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {ItemTypeClass} from '@emm/core/models/item-type-class.model';
import {RegexConstants} from '@emm/core/util/regex.constants';
import {AuthFacadeService} from '@emm/auth/services/auth-facade.service';
import {ItemTypeService} from '@emm/core/services/item-type.service';
import {TagService} from '@emm/core/services/tag.service';

@Component({
    selector: 'emm-add-item-type-dialog',
    styleUrls: ['./add-item-type-dialog.component.scss'],
    templateUrl: './add-item-type-dialog.component.html',
    standalone: false
})
export class AddItemTypeDialogComponent implements OnInit {

    private readonly destroyRef: DestroyRef = inject(DestroyRef);

    form: FormGroup;
    isReadOnly = this.authFacade.isReadOnly$;
    itemTypeClasses: Observable<ItemTypeClass[]>;
    name: string;
    spaceValidatorPattern = RegexConstants.STARTING_SPACE_VALIDATIOR_PATTERN;

    constructor(
        private authFacade: AuthFacadeService,
        public dialogRef: MatDialogRef<AddItemTypeDialogComponent>,
        public itemTypeService: ItemTypeService,
        public tagService: TagService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.buildForm();
        this.itemTypeClasses = this.data.itemTypeClasses;
    }


    ngOnInit(): void {
        this.dialogRef.updatePosition({top: '100px'});
    }


    closeAfterSubmit(): void {
        this.dialogRef.close('submit');
    }


    onNoClick(): void {
        this.dialogRef.close();
    }


    buildForm(): void {
        this.form = new FormGroup({
            classTag: new FormControl(''),
            description: new FormControl(''),
            name: new FormControl(''),
            tag: new FormControl('')
        });
    }


    findTagExists(): void {
        if (this.form.controls['tag'].valid) {
            this.tagService.getItemTypeTags(this.form.get('tag').value)
                .pipe(
                    takeUntilDestroyed(this.destroyRef)
                )
                .subscribe(res => {
                if (res) {
                    this.form.controls['tag'].setErrors({tagExists: true});
                }
            });
        }
    }


    OnSubmit(): void {
        if (this.form.valid) {
            const itemType = {
                classTag: this.form.controls['classTag'].value,
                description: this.form.controls['description'].value,
                name: this.form.controls['name'].value,
                tag: this.form.controls['tag'].value
            };
            this.itemTypeService.createItemType(itemType)
                .pipe(
                    takeUntilDestroyed(this.destroyRef)
                )
                .subscribe(() => {
                this.closeAfterSubmit();
            });
        }
    }


}
